import axios from "axios";
import FrontEndApiService from "@services/frontend.api.service";
import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
import {get} from "lodash";
import {runAsPublic} from "@helpers/api-helper";
import {pageRedirect} from "@helpers/router-helper";
export default {
    methods: {
        async checkUserExists(email, callbackIfOk = null, callbackIfError = null) {
            if (!email) {
                return false;
            }

            try {

                let {data} = await axios.post('/auth/check', {
                    email: email
                });

                callbackIfOk && await callbackIfOk(data);

                return Boolean(data?.status);
            } catch (error) {
                const response = error?.response || {};
                callbackIfError && await callbackIfError(response);
            }
        },
        async checkUserAppVersion(email, state, redirectTo, data = {}, callbackIfTrue = null) {
            let retValue = false;
            try {
                if (!!email && !!state) {

                    let response = await FrontEndApiService.post(`auth/checkStateApplicationVersion`, {
                        'email': email,
                        'state': state,
                        ...data
                    });

                    if (response.data.shouldRedirect && response.data.redirectUrl) {
                        callbackIfTrue && await callbackIfTrue(response, redirectTo);
                    }
                }

                retValue = true;
            } catch (error) {
                console.log("Error", error);
                throw Error;
            }

            return retValue;
        },
        async checkIfInvitedAgent(email, callbackIfTrue = null) {
            if (email) {
                return await runAsPublic(async () => {
                    const appResourceSearch = new AppResourceSearch('invitee-info');

                    await appResourceSearch.setSearchData({
                        pageSize: 1,
                        orderBy: {
                            createdAt: 'desc',
                        },
                        include: ['broker'],
                        filter: new ApiFilter({
                            params: {
                                email: email,
                                zoho_updated: false,
                                user_uuid: {
                                    operator: 'isNull',
                                    value: 'isNull',
                                },
                            },
                        }),
                    }, false);

                    await appResourceSearch.search();
                    const [invitation] = appResourceSearch.appResourceCollection.toArray();
                    if (Boolean(invitation)) {
                        callbackIfTrue && await callbackIfTrue(invitation);
                        return true;
                    }
                });
            }
            return false;
        },
        async checkIfInvitedSeller(email, token = null, callbackIfTrue = null, forceCallback = false) {
            if (!token && !email) {
                return;
            }
  
            return await runAsPublic(async () => {
                if(token){
                    let validToken = await FrontEndApiService.post(`/public-api/v1/invitations/validateToken`,{
                        invitationToken: token
                    });
                    if(validToken && validToken.status == 200 && !validToken.data.data.tokenValid){
                        await pageRedirect(window.env.APP_URL,`/invalid-invitation`);
                        return;
                    }  
                }

                const appResourceSearch = new AppResourceSearch('invitation');

                await appResourceSearch.setSearchData({
                    pageSize: 1,
                    orderBy: {
                        createdAt: 'desc',
                    },
                    filter: new ApiFilter({
                        params: token ? {
                            'token': token
                        } : {
                            meta: {
                                operator: "isNotNull",
                                value: true
                            },
                            'meta.primary_seller.email': {
                                operator: "contains",
                                value: email.toLowerCase()
                            }
                        },
                    }),
                }, false);

                await appResourceSearch.search();

                const [invitation] = appResourceSearch.appResourceCollection.toArray();

                if (Boolean(invitation)) {
                    let invitationMeta = get(invitation || {}, 'meta');
                    if (forceCallback || invitation?.acceptedAt == null || !token) {
                        callbackIfTrue && await callbackIfTrue(invitation);
                    }
                    return Boolean(invitationMeta);
                }
                return false;
            });
        },
        async validateConnectionInvitation(token = null, email = null, callbackIfTrue = null, forceCallback = false){
            if (!token && !email) {
                return;
            }       
            return await runAsPublic(async () => {
                let validToken = await FrontEndApiService.post(`/public-api/v1/invitations/validateConnectionToken`,{
                    connectionToken: token,
                    email: email
                });
                callbackIfTrue && await callbackIfTrue(validToken.data.data);
                return Boolean(validToken.data.data.validToken);
            })     
        }
    },
};
